var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.65 9.18v7.42m9.78-14.44.75 2.01 2.01.75-2.01.74-.75 2.02-.74-2.02-2.02-.74 2.02-.75.74-2.01Zm-2.1 13.52 1.36-1.34 2.03 1.4 1.64-2.01 1.72 2.06A2.92 2.92 0 0 0 23 12.76c-.03-1.7-1.3-3.09-2.92-3.11l-9.85-.14v-.44c-.04-2.66-2.05-4.86-4.58-4.9A4.65 4.65 0 0 0 1 8.93v7.9a4.88 4.88 0 0 0 4.65 4.9 4.6 4.6 0 0 0 4.58-4.76v-1.32l3.1.03Zm5.03 1.29.75 2.01 2.01.75-2.01.74-.75 2.02-.74-2.02-2.01-.74 2.01-.75.74-2.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPassword);
export default __webpack_public_path__ + "static/media/new_password.4bc7ded99ccb2b56941fbd87589e8ad0.svg";
export { ForwardRef as ReactComponent };